//@ts-nocheck

import styled from 'styled-components'
import { Paragraph, Heading } from '../../atoms/Typography/Typography.styles'

interface BentoBoxCaseProps {
  colorScheme?: string
  withBackground?: boolean
}

export const BentoBoxCase = styled.div<BentoBoxCaseProps>`
  width: 100%;
`

export const BentoBoxCaseGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: 1fr;
  gap: ${({ theme }) => theme.rem(24)};

  ${({ theme }) => theme.mediaQuery.md(`
    grid-template-columns: repeat(2, 1fr);
    gap: ${theme.rem(32)};
  `)}
`

export const BentoBoxCaseCardWrapper = styled.div`
  width: 100%;
`

